import { useState, useEffect } from "react";
import Container from "@/components/container";
import MoreStories from "@/components/more-stories";
import HeroSlider from "@/components/hero-slider"; // Import HeroSlider
import Intro from "@/components/intro";
import Layout from "@/components/layout";
import Head from "next/head";
import { getAllPostsForHome, getAllTags, getRecentlyUpdatedPosts } from "@/lib/api";
import RecentColleges from "@/components/getBlogposts";
import Script from "next/script";
import { format, parseISO } from "date-fns";
//import WebinarModal from "@/components/WebinarModal";
import OneToOneSession from "@/components/OneToOneSessionModal";
import Tabs from "@/components/Tabsforblogspart";

export default function Index({ initialPosts, allTags, recentlyUpdatedPosts }) {
  const [postsPerPage, setPostsPerPage] = useState(9);
  // Webinar modal state and timer
  //const [showWebinarModal, setShowWebinarModal] = useState(false);
  const [showOneToOneModal, setShowOneToOneModal] = useState(false);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowWebinarModal(true);
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOneToOneModal(true);
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredPosts, setFilteredPosts] = useState(initialPosts);
  const [activeTag, setActiveTag] = useState(null);
  const [reviews, setReviews] = useState({});
  const [allPosts, setAllPosts] = useState(initialPosts);
  const [heroPostsList, setHeroPostsList] = useState(recentlyUpdatedPosts || []);
  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const renderStars = (averageRating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
        fill={index < averageRating ? "#FF9346" : "none"}
        stroke={index < averageRating ? "#FF9346" : "#ccc"}
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ));
  };

  const fetchAverageReviews = async (postId) => {
    try {
      const res = await fetch(
        `${API_URL}/api/reviews/fetchAverageReviews?postId=${postId}`
      );
      const data = await res.json();
      setReviews((prevReviews) => ({
        ...prevReviews,
        [postId]: data.averageRating,
      }));
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    filteredPosts.forEach((post) => {
      fetchAverageReviews(post.id);
    });
    // Also fetch reviews for hero posts
    heroPostsList.forEach((post) => {
      fetchAverageReviews(post.id);
    });
  }, [filteredPosts, heroPostsList]);

  const startIdx = (currentPage - 1) * postsPerPage;
  const currentPosts = filteredPosts.slice(startIdx, startIdx + postsPerPage);

  const formatDate = (dateString) => {
    const date = parseISO(dateString);
    if (isNaN(date)) {
      return "Invalid date";
    }
    return format(date, "MMMM dd, yyyy");
  };

  const filterPostsByTag = (tagName) => {
    if (!tagName) {
      return;
    }
    const filtered = allPosts.filter(
      (post) => post.tags && post.tags.some((tag) => tag.name === tagName)
    );
    setFilteredPosts(filtered);
    setCurrentPage(1);
    setActiveTag(tagName);
  };

  const resetFilter = () => {
    setActiveTag(null);
    setFilteredPosts(allPosts);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  const fetchMorePosts = async (page) => {
    const res = await fetch(`/api/posts?page=${page}&limit=${postsPerPage}`);
    const data = await res.json();
    return data.posts;
  };

  // Use recently updated posts for hero slider
  const heroPosts = heroPostsList.map((post) => ({
    ...post,
    feature_image: post.feature_image ? post.feature_image.replace("ghost.", "") : "/default.jpg",
    averageRating: reviews[post.id] || 0,
  }));

  return (
    <>
        {/* <WebinarModal
          isOpen={showWebinarModal}
          onClose={() => setShowWebinarModal(false)}
        /> */}
        <OneToOneSession
          isOpen={showOneToOneModal}
          onClose={() => setShowOneToOneModal(false)}
        />
      <Layout>
        <Head>
          <title>NEET Support Blogs— NEET News and Updates</title>
          <link rel="shortcut icon" href="/favicon.ico" />
          <meta
            name="description"
            content="Explore NEET Support Latest detailed blogs for neet counseling tips, exam updates,fee structure,college lists and admission processes. all about counselling"
          />
          <meta
            name="keywords"
            content="neet counselliing, neet exam, neet 2026, news and updates ,"
          />
          <meta property="og:title" content="neet supoort News & Blogs" />
          <meta
            property="og:description"
            content="Check out the latest posts! detailed news and updates on neet couselling"
          />
          <meta
            property="og:image"
            content={
              heroPosts[0]?.feature_image.replace("ghost.", "") ||
              "/default.jpg"
            }
          />
          <meta
            property="og:url"
            content={typeof window !== "undefined" ? window.location.href : ""}
          />
          <link rel="canonical" href="https://neetsupport.com/blogs" />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: `
            {
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              "name": "NEET Support Blogs – NEET News and Updates",
              "description": "Explore NEET Support’s latest blogs for NEET counselling tips, exam updates, fee structure, college lists, and admission processes.",
              "url": "https://neetsupport.com/blogs"
            }
          `,
            }}
          />
        </Head>
        <Container>
          {/* <Intro /> */}
          <div className="w-full pb-4 hidden bg-[#005f59]">
            {" "}
            <h1 className="text-center pt-8 lg:text-3xl underline md:text-lg text-sm font-bold  text-[#fff]">
              Latest NEET 2026 Updates, Exam Tips & College Guidance
            </h1>
          </div>
          {heroPosts.length > 0 && (
            <div className="hero-slider mb-10">
              <HeroSlider posts={heroPosts} />
            </div>
          )}

          {isLoading ? (
            <div className="skeleton-loader">Loading...</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-12 cursor-pointer py-2 mt-10">
              {currentPosts.map((post) => (
                <a
                  key={post.id}
                  href={`/blogs/${post.slug}`}
                  className="bg-white shadow-md rounded-lg overflow-hidden relative group block"
                >
                  <img
                    src={post.feature_image.replace("ghost.", "")}
                    alt={post.title}
                    className="w-full h-auto object-contain"
                  />
                  {/* Tags Section */}
                  <div className="absolute top-4 left-0 flex flex-wrap z-20 transform transition-transform duration-500 group-hover:scale-105">
                    {post.tags.map((tag) => (
                      <span
                        key={tag.id}
                        className="bg-[#FF9346] text-white text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-r-full"
                      >
                        {tag.name}
                      </span>
                    ))}
                  </div>
                  <div className="p-4">
                    <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
                    <div className="flex justify-between items-center mb-4 text-gray-500">
                      <span>{formatDate(post.published_at)}</span>
                      <div className="flex items-center">
                        {renderStars(reviews[post.id] || 0)}
                      </div>
                    </div>

                    <p className="text-gray-700 mb-4">{post.excerpt}</p>

                    <a
                      href={`/blogs/${post.slug}`}
                      className="text-blue-500 hover:underline"
                    >
                      Read more
                    </a>
                  </div>
                </a>
              ))}
            </div>
          )}

          <div className=" mt-8 mb-4">
            <div className="flex justify-center items-center space-x-4">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`p-2 rounded-full border border-gray-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-300 ease-in-out transform hover:scale-105 ${
                  currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                }`}
                aria-label="Previous Page"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>

              <span className="text-sm text-gray-700 font-medium">
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`p-2 rounded-full border border-gray-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-300 ease-in-out transform hover:scale-105 ${
                  currentPage === totalPages
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                aria-label="Next Page"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>

          <Tabs />
        </Container>
      </Layout>
    </>
  );
}

export async function getStaticProps({ preview }) {
  const initialPosts = (await getAllPostsForHome(preview)) || [];
  const allTags = (await getAllTags()) || [];
  const recentlyUpdatedPosts = (await getRecentlyUpdatedPosts(preview, 4)) || [];

  return {
    props: { initialPosts, allTags, recentlyUpdatedPosts },
    revalidate: 10,
  };
}
